//storedSettings.ts — the avatar mirror's Decart setting, kept per device like the camera settings

import type { CharacterOverride } from '../tryon/characterOverride'

const STORAGE_KEY = 'avatar.settings.v1'

//Decart's default: enhance on.
export const DEFAULT_SETTINGS: CharacterOverride = { enhance: true }

//Anything read back from storage is untrusted input.
export function loadSettings(): CharacterOverride {
	try {
		const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}') as Record<string, unknown>
		return { enhance: typeof raw.enhance === 'boolean' ? raw.enhance : DEFAULT_SETTINGS.enhance }
	} catch {
		return DEFAULT_SETTINGS
	}
}

export function saveSettings(settings: CharacterOverride): CharacterOverride {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(settings))
	} catch {
		//Private-mode Safari throws on write. Losing persistence is acceptable; crashing is not.
	}
	return settings
}
